/**
 * Prefix of row ids minted locally for not-yet-submitted additions.
 * Draft rows never exist on the backend: the submit path POSTs them and
 * the remove path just drops them instead of staging a DELETE.
 */
export const PENDING_ROW_PREFIX = '__pending__';

/**
 * `true` when the row id was minted locally for a not-yet-submitted addition.
 * Exposed so views can render draft rows with distinct visual treatment.
 */
export const isDraftRowId = (id: string): boolean => id.startsWith(PENDING_ROW_PREFIX);
